import React from 'react'
import { StyleSheet, css } from 'aphrodite'

// MATERIAL
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

// EXTRA COMPONENTS

import Contact from './Parts/Contact'
import Location from './Parts/Location'
import Social from './Parts/Social'

// IMAGES
import logo from '../../assets/logo.svg'

export default class Footer extends React.Component{
    render(){
    return(
        <section id="Footer" className={css(styles.MainContainer)}>
            <div className="container">
                <section className={css(styles.SecondaryContainer)}>
                    <Grid container spacing="40" justify="center" alignItems="flex-start">
                        <Grid item md={2}>
                            <a href="/">
                                <img className={css(styles.logo)} src={logo} alt=""/>
                            </a>
                        </Grid>
                        <Grid className={css(styles.GridItem)} item md={2} xs={10}>
                            <Contact />
                        </Grid>
                        <Grid className={css(styles.GridItem)} item md={2} xs={10}>
                           <Location />
                        </Grid>
                        <Grid className={css(styles.GridItem)} item md={2} xs={10}>
                            <Social />
                        </Grid>
                    </Grid>
                </section>
            </div>
            <div className="container" style={{textAlign: 'center', marginTop: '5em'}}>
                <Typography variant="caption" style={{color: 'white', marginTop: 40, paddingBottom: 10}}>
                    © 2018 - Lemonat.io Registered Trademark
                </Typography>
                
            </div>
        </section>
    )
  }
}
    
const styles = StyleSheet.create({
    logo : {
        height: 50,
        opacity: 1,
        ':hover' :{
            opacity: .9
        }
    },
    MainContainer: {
        minHeight: 360,
        position: 'relative',
        background: 'linear-gradient(-69deg, #4D88FF, #457FDD)',
        '@media (min-width: 1500px)' : {
            minHeight: 500,
        }
        // marginTop: -100
    },
    SecondaryContainer: {
        paddingTop: '5em',
    	color: '#595959',
        lineHeight: '1.8em',
        '@media (max-width: 768px)':{
            // paddingTop: '100%'
        }
    },

    GridItem : {
        marginTop: '15px',
        '@media (max-width: 768px)':{
            textAlign: 'center'
        }
    }
});


// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js